import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import '../css/Home.css';
import Card from './Card';
import scope from '../assets/cl3.jpg';
// import serimg from '../assets/serimg.png'
import { FaArrowCircleLeft, FaArrowCircleRight, FaReadme, FaOdnoklassniki } from 'react-icons/fa';
import first from '../assets/cl.jpg'
import second from '../assets/pw.jpg'
import third from '../assets/rw.jpg'
import four from '../assets/kw.jpg'
import five from '../assets/kmtw.jfif'




const Home = () => {

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);


    function toleft() {
        document.getElementById("hrlistid").scrollBy(-430, 0)
    }
    function toright() {
        document.getElementById("hrlistid").scrollBy(430, 0)
    }
    function serleft() {
        document.getElementById("listservice").scrollBy(-400, 0)
    }
    function serright() {
        document.getElementById("listservice").scrollBy(400, 0)
    }
    // window.setInterval(serright,2000);
    // window.setInterval(toright, 3000);

    return (
        <div className="homeoutercontainer">
            <div className=" fcontainer " >
                <div className="inner " >

                    <div className="innerflexone">
                        <h1 className="tit" >Welcome To Al MAKKAH FENCE</h1>
                        <h3 className="txt" >Iron Manufacturers and Marketers modern trends are shifted towards new Iron wire design e.g Chainlink, Razorwire, Kirmat etc.</h3>

                    </div>

                </div>


            </div>
            <div className="spart" >
                <div className="scont" >
                    <div className="simgcont" >
                        <img src={scope} alt='no img' className="simg" />
                    </div>
                    <div>
                        <h1 className="shead" >Al Makkah Fence Developments</h1>
                        <div className="spara" >
                            The foundation of our company is built upon a unique blend of diversity and exclusivity, which gives us the capability to gather talent from across the world from different countries and cultures. This gives us immense strength to achieve our goals efficiently and effectively. Providing technical consulting services / strategic candidate headhunting, within niche skill-sets, for both freelance and permanent staff is the lifeline of our business. We believe that people are at the core of our business and they are the most effective tool to achieve company’s goal. This is the very reason which ensured our continuous and sustainable growth in all our markets.
                        </div>
                    </div>

                </div>

            </div>
            <div className="sercontain" >
                <div className="sercontaininmaxwidth">
                    <div className="serdata" >
                        <h1>Our Services</h1>
                        <div className="serpara">We recognize that each client and candidate is unique. Therefore, we strive to truly understand each business and its Scientific needs. By doing so, this allows us to utilize our knowledge and experience within the market, in order to advise and consult accordingly, in turn creating valued and long-term partnerships.</div>
                    </div>
                    <Card />
                </div>
            </div>
            <div className="com">
                <div className="cominner">
                    <h2 className="comhead" >We are a unique fence service provider with years of experience</h2>
                </div>
                <div className="countries" >
                    <div className="innercontent" >
                        <div className="number" >
                            <span>35</span>
                            <span>+</span>
                        </div>
                        <div className="contriesname">
                            Cities
                        </div>
                    </div>
                </div>
                <div className="countries candidate" >
                    <div className="innercontent" >
                        <div className="number wc"  >
                            <span>50</span>
                            <span>+</span>
                        </div>
                        <div className="contriesname wc">
                            Labour Pool
                        </div>
                    </div>
                </div>
                <div className="countries cl" >
                    <div className="innercontent" >
                        <div className="number" >
                            <span>50</span>
                            <span>+</span>
                        </div>
                        <div className="contriesname">
                            Fence Clients
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="phrase" >
                <div className="icon">
                    <h1  >""</h1>
                </div>
                <h2 className="jobhead" >What Clients Think About Us</h2>
                <div className="ptxt" >
                    Perfection comes from specialization and practice. Likewise, serving the Life industry over many years has allowed us to nurture a network of leading experts from across the country.
                </div>
            </div>
            
        </div>

    )
}
export default Home;